import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { PageLayout } from "@/components/PageLayout";
import { Reveal } from "@/components/Reveal";
import { resourceCategories } from "@/data/resources";

export default function ResourcesHub() {
  const [featured, ...rest] = resourceCategories;
  const FeaturedIcon = Icons[featured.icon] || Icons.BookOpen;
  return (
    <PageLayout
      seoTitle="Cybersecurity Resources & Research | Aliwer"
      seoDescription="Cybersecurity resources from Aliwer: practical guides, risk research reports, checklists, and engineering insights."
      path="/resources"
      eyebrow="Resources"
      title="Resources & research."
      subtitle="Guides, reports, checklists, and engineering insights to help you build and prove a stronger security posture."
      testid="resources-hub"
    >
      <div className="grid gap-5 lg:grid-cols-[1.3fr_1fr]">
        {/* Featured category */}
        <Reveal>
          <Link
            to={`/resources/${featured.slug}`}
            data-testid={`resource-card-${featured.slug}`}
            className="group flex flex-col justify-between h-full rounded-2xl border border-white/15 bg-surface p-8 md:p-10 hover:bg-[#232326] transition-colors duration-500"
          >
            <div>
              <span className="inline-block text-[10px] uppercase tracking-widest border border-white/25 text-paper rounded-full px-2.5 py-1 mb-6">
                Featured
              </span>
              <FeaturedIcon size={30} className="text-paper mb-6" strokeWidth={1.2} />
              <h2 className="font-display text-3xl tracking-tight text-paper mb-3">{featured.title}</h2>
              <p className="text-sm text-fog leading-relaxed max-w-lg">{featured.intro}</p>
            </div>
            <span className="mt-8 inline-flex items-center gap-1 text-xs uppercase tracking-widest text-paper">
              Browse
              <Icons.ArrowUpRight size={13} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </span>
          </Link>
        </Reveal>

        {/* Category list */}
        <div className="rounded-2xl border border-white/10 overflow-hidden divide-y divide-white/10 self-start" data-testid="resources-list">
          {rest.map((r, i) => {
            const Icon = Icons[r.icon] || Icons.BookOpen;
            return (
              <Reveal key={r.slug} delay={i * 0.04}>
                <Link
                  to={`/resources/${r.slug}`}
                  data-testid={`resource-card-${r.slug}`}
                  className="group flex items-start gap-4 px-6 py-6 bg-black/40 hover:bg-surface transition-colors duration-300"
                >
                  <Icon size={18} className="text-paper mt-0.5 shrink-0" strokeWidth={1.4} />
                  <span className="flex-1">
                    <span className="block font-display text-lg tracking-tight text-paper">{r.title}</span>
                    <span className="mt-1 block text-sm text-fog leading-relaxed">{r.intro}</span>
                  </span>
                  <Icons.ArrowUpRight
                    size={15}
                    className="text-fog mt-1 transition-all duration-300 group-hover:text-paper group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  />
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </PageLayout>
  );
}
